import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Challenge() {
  return (
    <section className="challenge_par challenge_nurs p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={6} xl={5} xxl={5} className="my-auto">
            <h2>
              Challenges & <span style={{ color: "#6D4FC1" }}>Solutions</span>
            </h2>
            <p>
              Building an application as unique as the Nurse Practitioners
              requires experience and technical excellence. Even a team as
              expert as that of TekRevol had to pull out all their strings to
              make this a success. From integrating video calls and consultation
              to incorporating online payment options to calculating the final
              compensation inclusive and exclusive of taxes – building this
              application was an exciting challenge that we wholeheartedly
              accepted. When we first got this project, it went through a
              careful and thorough assessment where we took care of all the
              factors and features that can be significant for the application.
              After extensive study, our experts proposed a solution that solved
              the problems and presented a comprehensive solution.
            </p>
            <p>
              From the beginning of the project, during its development, and
              after the launch – we ensured that each module of the complete
              project was thoroughly looked after and built as per the industry
              standards. After the launch, it was made sure that the app reached
              the right audience.From the beginning of the project, during its
              development, and after the launch – we ensured that each module of
              the complete project was thoroughly looked after and built as per
              the industry standards. After the launch, it was made sure that
              the app reached the right audience.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-2 offset-lg-1"
          >
            <div className="challenge_img text-center">
              <StaticImage
                src="../../../images/case-studies/nurse-practition/tek_img_02.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={703}
                height={566}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challenge;
